import {createRefetchContainer, graphql} from 'react-relay';

const MonthByMonthClientLoader = ({viewer, children, ...props}) => {
	const formatData = () => {
		return viewer.company.financialBasedClients.edges.map(client => {
			const {aggregatedFinancialNumbers, timeAggregatedFinancialNumbers, expenseAggregatedFinancialNumbers} = client.node;
			return {
				client: {
					...client.node,
				},
				currency: viewer.company.currency,
				aggregatedFinancialNumbers: {
					...aggregatedFinancialNumbers,
				},
				timeAggregatedFinancialNumbers: {
					...timeAggregatedFinancialNumbers,
				},
				expenseAggregatedFinancialNumbers: {
					...expenseAggregatedFinancialNumbers,
				},
			};
		});
	};

	return children({data: {rows: formatData()}, ...props});
};

export const monthByMonthClientLoaderQuery = graphql`
	query MonthByMonthClientLoader_Query(
		$startYear: Int!
		$startMonth: Int!
		$startDay: Int!
		$endYear: Int!
		$endMonth: Int!
		$endDay: Int!
		$searchQuery: TaskSearchQueryType!
		$timeSearchQuery: TaskSearchQueryType!
		$expenseSearchQuery: TaskSearchQueryType!
		$selectedSingleValue: FinancialAggregatedNumber!
		$ignoreBaselineWinChance: Boolean
		$excludeOpportunityActuals: Boolean
	) {
		viewer {
			actualPersonId
			component(name: "project_portfolio_month_by_month_client_loader")
			...MonthByMonthClientLoader_viewer
				@arguments(
					searchQuery: $searchQuery
					timeSearchQuery: $timeSearchQuery
					expenseSearchQuery: $expenseSearchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					selectedSingleValue: $selectedSingleValue
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				)
		}
	}
`;

export default createRefetchContainer(MonthByMonthClientLoader, {
	viewer: graphql`
		fragment MonthByMonthClientLoader_viewer on Viewer
		@argumentDefinitions(
			searchQuery: {type: "TaskSearchQueryType!"}
			timeSearchQuery: {type: "TaskSearchQueryType!"}
			expenseSearchQuery: {type: "TaskSearchQueryType!"}
			startYear: {type: "Int!"}
			startMonth: {type: "Int!"}
			startDay: {type: "Int!"}
			endYear: {type: "Int!"}
			endMonth: {type: "Int!"}
			endDay: {type: "Int!"}
			selectedSingleValue: {type: "FinancialAggregatedNumber!"}
			ignoreBaselineWinChance: {type: "Boolean"}
			excludeOpportunityActuals: {type: "Boolean"}
		) {
			id
			company {
				currency
				financialBasedClients(
					searchQuery: $searchQuery
					startYear: $startYear
					startMonth: $startMonth
					startDay: $startDay
					endYear: $endYear
					endMonth: $endMonth
					endDay: $endDay
					aggregateLevel: MONTH
					aggregates: [$selectedSingleValue]
					ignoreBaselineWinChance: $ignoreBaselineWinChance
					excludeOpportunityActuals: $excludeOpportunityActuals
				) {
					edges {
						node {
							id
							name
							aggregatedFinancialNumbers(
								startYear: $startYear
								startMonth: $startMonth
								startDay: $startDay
								endYear: $endYear
								endMonth: $endMonth
								endDay: $endDay
								aggregateLevel: MONTH
								aggregates: [$selectedSingleValue]
								ignoreBaselineWinChance: $ignoreBaselineWinChance
								excludeOpportunityActuals: $excludeOpportunityActuals
							)
							timeAggregatedFinancialNumbers: aggregatedFinancialNumbers(
								searchQuery: $timeSearchQuery
								startYear: $startYear
								startMonth: $startMonth
								startDay: $startDay
								endYear: $endYear
								endMonth: $endMonth
								endDay: $endDay
								aggregateLevel: MONTH
								aggregates: [$selectedSingleValue]
								fetchOwnData: true
								ignoreBaselineWinChance: $ignoreBaselineWinChance
								excludeOpportunityActuals: $excludeOpportunityActuals
							)
							expenseAggregatedFinancialNumbers: aggregatedFinancialNumbers(
								searchQuery: $expenseSearchQuery
								startYear: $startYear
								startMonth: $startMonth
								startDay: $startDay
								endYear: $endYear
								endMonth: $endMonth
								endDay: $endDay
								aggregateLevel: MONTH
								aggregates: [$selectedSingleValue]
								fetchOwnData: true
								ignoreBaselineWinChance: $ignoreBaselineWinChance
								excludeOpportunityActuals: $excludeOpportunityActuals
							)
						}
					}
				}
			}
		}
	`,
});
